// Automatically generated from TW.Saga.Core.Schema, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null @15.06.2017 16:59:22
import { ServiceResource_abstract } from './../abstract/SagaSchema/ServiceResource_abstract';
export class ServiceResource extends ServiceResource_abstract {}
